<div class="mb-0">
  <!-- <span class="accordion-header">{{ accordionData.heading }}</span> -->
  <div [id]="accordionData.id" class="myaccordion">
    <div
      class="card"
      *ngFor="let accordion of accordionData.accordion; let i = index"
    >
      <div class="card-header">
        <div class="mb-0">
          <div
            class="btn-link {{ accordion.class }}"
            [attr.data-target]="'#' + accordion.id"
            (click)="collapseStatusChange(accordion)"
            [attr.aria-expanded]="accordion.isToggle"
            aria-controls="collapse"
          >
            <span class="fa-stack fa-sm">
              <!-- <i
                [ngClass]="{
                  'fa-minus': accordion.isToggle,
                  'fa-plus': !accordion.isToggle
                }"
                [class]="accordion.icon"
              >
              </i> -->
            </span>
            <span
              class="acco-header"
              [ngClass]="{
                minus: accordion.isToggle,
                plus: !accordion.isToggle
              }"
            >
              {{ accordion.subHeading }}
            </span>
          </div>
        </div>
      </div>
      <div
        [id]="accordion.id"
        class="collapse"
        [ngClass]="{ show: accordion.isToggle }"
        aria-labelledby="headingOne"
        [attr.data-parent]="'#' + accordionData.id"
      >
        <ng-container
          *ngTemplateOutlet="gridTemplate ? gridListTemplate : contentTemplate"
        ></ng-container>
      </div>
      <ng-template #gridListTemplate>
        <div *ngIf = "accordion.isAdvSearch">
          &nbsp;&nbsp;Search by<br/>
        &nbsp;&nbsp;
        <select id="selectSearchBy" [(ngModel)]="selectedSearchBy" style="width:20%;height: 30px;">
        <!-- <option value="InsuredName">Insured Name</option> -->
        <option value="PolicyNumber">Policy Number</option>
        <option value="SubmissionID">Submission ID</option>
        </select>&nbsp;&nbsp;
        <input type="text" id="txtSearch" maxlength="200" [(ngModel)]="enteredSearchText"/>&nbsp;&nbsp;      
        <button type="button" id="btnSearch" (click)="searchByClicked()" class="btn btn-primary" style="float: right;margin-right: 5%;border-radius: 5px;">Search</button>
        </div>
        <div
          class="card-body pb-0"
          *ngIf="accordion.gridDefination?.data?.length"
        >
          <div id="{{ 'gridListContainer' + accordionData.id }}">
            <!-- <div style="float:right">
              <span style="margin: 0.4em;">
                <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
              </span>
              <span>
                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
              </span>
            </div> -->
            <div *ngIf="accordion.gridDefination?.data.length > 0">
              <ac-grid-table
                (eventForStandardGrid)="
                  selectedValues($event, accordionData.id, accordion)
                "
                [parentDivName]="'gridListContainer' + accordionData.id"
                [gridSetting]="accordion.gridDefination?.gridOptions"
                [isDeleteOption]="false"
                [isCheckbox]="
                  getCheckboxRequiredStatus(accordion.gridDefination)
                "
                [records]="accordion.gridDefination?.data"
                [columnSettings]="accordion.gridDefination?.columnDefination"
              ></ac-grid-table>
            </div>
          </div>
          <div
            class="button-row no-border mt-0"
            *ngIf="
              accordion.gridDefination?.data.length || accordion.buttonGroup
            "
          >
            <ng-container *ngFor="let button of accordion.buttonGroup">
              <button
                [disabled]="button.isDisabled"
                [ngStyle]="{
                  cursor: button.isDisabled == true ? 'not-allowed' : 'pointer'
                }"
                type="button"
                [class]="button.btnClass"
                (click)="gridButtonClikAction(button)"
              >
                {{ button.label }}
              </button>
            </ng-container>
          </div>
        </div>
        <div
          *ngIf="!accordion.gridDefination?.data.length && !accordion.loading"
        >
          <p class="text-center mt-3"><strong>No Data found</strong></p>
        </div>
        <div
          *ngIf="accordion.loading && (!accordion.gridDefination?.data.length || accordion.gridDefination?.data.length == 0) && accordion.isServiceError"
        >
        <p class="text-center mt-3"><strong>Data could not be loaded. Please try again.</strong></p>
      </div> 
      <div
          *ngIf="accordion.loading && (!accordion.gridDefination?.data.length || accordion.gridDefination?.data.length == 0) && !accordion.isServiceError"
        >
          <p class="text-center mt-3"><strong>Please wait</strong></p>
      </div>            
      </ng-template>
      <ng-template #contentTemplate>
        <div class="card-body p-0" *ngIf="accordion.content.type == 'link'">
          <ul class="risk-list">
            <li *ngFor="let data of accordion.content.data">
              <a href="javascript:void(0);" (click)="clickedLink(data)">
                {{ data.content }}
              </a>
            </li>
          </ul>
        </div>
        <div class="card-body" *ngIf="accordion.content.type != 'link'">
          <span>
            {{ accordion.content.data }}
          </span>
        </div>
      </ng-template>
    </div>
  </div>
</div>
